import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#filter0_d_1723_6207)">
        <rect
          x="7"
          y="7"
          width="24"
          height="24"
          rx="12"
          fill="url(#paint0_linear_1723_6207)"
          shapeRendering="crispEdges"
        />
        <rect
          x="7.375"
          y="7.375"
          width="23.25"
          height="23.25"
          rx="11.625"
          stroke="#F59C53"
          strokeWidth="0.75"
          shapeRendering="crispEdges"
        />
        <path
          d="M23.8685 14.0065L20.0637 18.7375L23.8685 23.4685L23.5407 23.725L19.7075 18.937H19.5792H19.0092V21.2882H18.6102V18.937H18.0402H17.912L14.0787 23.725L13.751 23.4685L17.5557 18.7375L13.751 14.0065L14.0787 13.75L17.912 18.538H18.0402H18.6102V16.1867H19.0092V18.538H19.5792H19.7075L23.5407 13.75L23.8685 14.0065Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1723_6207"
          x="-5.8984"
          y="-5.8984"
          width="49.7968"
          height="49.7968"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.38583" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1723_6207" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1723_6207" result="shape" />
        </filter>
        <linearGradient id="paint0_linear_1723_6207" x1="19" y1="7" x2="19" y2="31" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1C1C1C" />
          <stop offset="1" stopColor="#7B4E2A" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Icon;
